// extracted by mini-css-extract-plugin
module.exports = {"component":"statistics_component_30Lhr","stat-column":"statistics_stat-column_1Ree9"};